export default "__VITE_ASSET__5D673PyX__"